'use strict';

var _objectSpread = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var DeepEqual = require('@hapi/hoek/lib/deepEqual');
var Pinpoint = require('@hapi/pinpoint');
var Errors = require('./errors');
var internals = {
  codes: {
    error: 1,
    pass: 2,
    full: 3
  },
  labels: {
    0: 'never used',
    1: 'always error',
    2: 'always pass'
  }
};
exports.setup = function (root) {
  var trace = function trace() {
    root._tracer = root._tracer || new internals.Tracer();
    return root._tracer;
  };
  root.trace = trace;
  root[Symbol.for('@hapi/lab/coverage/initialize')] = trace;
  root.untrace = function () {
    root._tracer = null;
  };
};
exports.location = function (schema) {
  return schema.$_setFlag('_tracerLocation', Pinpoint.location(2)); // base.tracer(), caller
};
internals.Tracer = /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
    this.name = 'Joi';
    this._schemas = new Map();
  }
  _createClass(_class, [{
    key: "_register",
    value: function _register(schema) {
      var existing = this._schemas.get(schema);
      if (existing) {
        return existing.store;
      }
      var store = new internals.Store(schema);
      var _ref = schema._flags._tracerLocation || Pinpoint.location(5),
        filename = _ref.filename,
        line = _ref.line; // internals.tracer(), internals.entry(), exports.entry(), validate(), caller
      this._schemas.set(schema, {
        filename: filename,
        line: line,
        store: store
      });
      return store;
    }
  }, {
    key: "_combine",
    value: function _combine(merged, sources) {
      var _iterator = _createForOfIteratorHelper(this._schemas.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var store = _step.value.store;
          store._combine(merged, sources);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "report",
    value: function report(file) {
      var coverage = [];

      // Process each registered schema
      var _iterator2 = _createForOfIteratorHelper(this._schemas.values()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
            filename = _step2$value.filename,
            line = _step2$value.line,
            store = _step2$value.store;
          if (file && file !== filename) {
            continue;
          }

          // Process sub schemas of the registered root

          var missing = [];
          var skipped = [];
          var _iterator3 = _createForOfIteratorHelper(store._sources.entries()),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                schema = _step3$value[0],
                log = _step3$value[1];
              // Check if sub schema parent skipped

              if (internals.sub(log.paths, skipped)) {
                continue;
              }

              // Check if sub schema reached

              if (!log.entry) {
                missing.push({
                  status: 'never reached',
                  paths: _toConsumableArray(log.paths)
                });
                skipped.push.apply(skipped, _toConsumableArray(log.paths));
                continue;
              }

              // Check values

              for (var _i = 0, _arr = ['valid', 'invalid']; _i < _arr.length; _i++) {
                var type = _arr[_i];
                var set = schema["_".concat(type, "s")];
                if (!set) {
                  continue;
                }
                var values = new Set(set._values);
                var refs = new Set(set._refs);
                var _iterator4 = _createForOfIteratorHelper(log[type]),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _step4$value = _step4.value,
                      value = _step4$value.value,
                      ref = _step4$value.ref;
                    values.delete(value);
                    refs.delete(ref);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                if (values.size || refs.size) {
                  missing.push({
                    status: [].concat(_toConsumableArray(values), _toConsumableArray(_toConsumableArray(refs).map(function (ref) {
                      return ref.display;
                    }))),
                    rule: "".concat(type, "s")
                  });
                }
              }

              // Check rules status

              var rules = schema._rules.map(function (rule) {
                return rule.name;
              });
              for (var _i2 = 0, _arr2 = ['default', 'failover']; _i2 < _arr2.length; _i2++) {
                var _type = _arr2[_i2];
                if (schema._flags[_type] !== undefined) {
                  rules.push(_type);
                }
              }
              var _iterator5 = _createForOfIteratorHelper(rules),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var name = _step5.value;
                  var status = internals.labels[log.rule[name] || 0];
                  if (status) {
                    var report = {
                      rule: name,
                      status: status
                    };
                    if (log.paths.size) {
                      report.paths = _toConsumableArray(log.paths);
                    }
                    missing.push(report);
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (missing.length) {
            coverage.push({
              filename: filename,
              line: line,
              missing: missing,
              severity: 'error',
              message: "Schema missing tests for ".concat(missing.map(internals.message).join(', '))
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return coverage.length ? coverage : null;
    }
  }]);
  return _class;
}();
internals.Store = /*#__PURE__*/function () {
  function _class2(schema) {
    _classCallCheck(this, _class2);
    this.active = true;
    this._sources = new Map(); // schema -> { paths, entry, rule, valid, invalid }
    this._combos = new Map(); // merged -> [sources]
    this._scan(schema);
  }
  _createClass(_class2, [{
    key: "debug",
    value: function debug(state, source, name, result) {
      state.mainstay.debug && state.mainstay.debug.push({
        type: source,
        name: name,
        result: result,
        path: state.path
      });
    }
  }, {
    key: "entry",
    value: function entry(schema, state) {
      internals.debug(state, {
        type: 'entry'
      });
      this._record(schema, function (log) {
        log.entry = true;
      });
    }
  }, {
    key: "filter",
    value: function filter(schema, state, source, value) {
      internals.debug(state, _objectSpread({
        type: source
      }, value));
      this._record(schema, function (log) {
        log[source].add(value);
      });
    }
  }, {
    key: "log",
    value: function log(schema, state, source, name, result) {
      internals.debug(state, {
        type: source,
        name: name,
        result: result === 'full' ? 'pass' : result
      });
      this._record(schema, function (log) {
        log[source][name] = log[source][name] || 0;
        log[source][name] |= internals.codes[result];
      });
    }
  }, {
    key: "resolve",
    value: function resolve(state, ref, to) {
      if (!state.mainstay.debug) {
        return;
      }
      var log = {
        type: 'resolve',
        ref: ref.display,
        to: to,
        path: state.path
      };
      state.mainstay.debug.push(log);
    }
  }, {
    key: "value",
    value: function value(state, by, from, to, name) {
      if (!state.mainstay.debug || DeepEqual(from, to)) {
        return;
      }
      var log = {
        type: 'value',
        by: by,
        from: from,
        to: to,
        path: state.path
      };
      if (name) {
        log.name = name;
      }
      state.mainstay.debug.push(log);
    }
  }, {
    key: "_record",
    value: function _record(schema, each) {
      var log = this._sources.get(schema);
      if (log) {
        each(log);
        return;
      }
      var sources = this._combos.get(schema);
      var _iterator6 = _createForOfIteratorHelper(sources),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var source = _step6.value;
          this._record(source, each);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "_scan",
    value: function _scan(schema, _path) {
      var _this = this;
      var path = _path || [];
      var log = this._sources.get(schema);
      if (!log) {
        log = {
          paths: new Set(),
          entry: false,
          rule: {},
          valid: new Set(),
          invalid: new Set()
        };
        this._sources.set(schema, log);
      }
      if (path.length) {
        log.paths.add(path);
      }
      var each = function each(sub, source) {
        var subId = internals.id(sub, source);
        _this._scan(sub, path.concat(subId));
      };
      schema.$_modify({
        each: each,
        ref: false
      });
    }
  }, {
    key: "_combine",
    value: function _combine(merged, sources) {
      this._combos.set(merged, sources);
    }
  }]);
  return _class2;
}();
internals.message = function (item) {
  var path = item.paths ? Errors.path(item.paths[0]) + (item.rule ? ':' : '') : '';
  return "".concat(path).concat(item.rule || '', " (").concat(item.status, ")");
};
internals.id = function (schema, _ref2) {
  var source = _ref2.source,
    name = _ref2.name,
    path = _ref2.path,
    key = _ref2.key;
  if (schema._flags.id) {
    return schema._flags.id;
  }
  if (key) {
    return key;
  }
  name = "@".concat(name);
  if (source === 'terms') {
    return [name, path[Math.min(path.length - 1, 1)]];
  }
  return name;
};
internals.sub = function (paths, skipped) {
  var _iterator7 = _createForOfIteratorHelper(paths),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var path = _step7.value;
      var _iterator8 = _createForOfIteratorHelper(skipped),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var skip = _step8.value;
          if (DeepEqual(path.slice(0, skip.length), skip)) {
            return true;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return false;
};
internals.debug = function (state, event) {
  if (state.mainstay.debug) {
    event.path = state.debug ? [].concat(_toConsumableArray(state.path), [state.debug]) : state.path;
    state.mainstay.debug.push(event);
  }
};